import { ApolloLink } from '@apollo/client';
import { map } from 'rxjs';

const ATTR_PREFIX = 'gql.';
const ATTR_OPERATION_NAME = `${ATTR_PREFIX}operationName`;
const ATTR_DURATION = `${ATTR_PREFIX}duration`;

export const dataDogRumLink = new ApolloLink((operation: ApolloLink.Operation, forward: ApolloLink.ForwardFunction) => {
	const { operationName } = operation;
	const startTime = performance.now();

	return forward(operation).pipe(
		map((result: ApolloLink.Result) => {
			const duration = performance.now() - startTime;
			const rumAPI = window['DD_RUM'];
			const initError = window['DD_RUM_INIT_ERROR'];
			// verify the RUM API is initialized (some ad blockers will block RUM)
			// otherwise we risk polluting the RUM onReady array with actions
			// that will never be cleaned up
			if (rumAPI && initError !== true) {
				rumAPI.onReady(() => {
					rumAPI.addAction('GraphQL Operation', {
						[ATTR_OPERATION_NAME]: operationName,
						[ATTR_DURATION]: duration
					});
				});
			}

			return result;
		})
	);
});
